import { businessKey } from 'queryKeys';

const INFLUENCERS_CAMPAIGNS = 'influencersCampaigns';
const influencersCampaignsQuery = businessKey.query(INFLUENCERS_CAMPAIGNS);

export const grids = influencersCampaignsQuery.grids();
export const grid = influencersCampaignsQuery.grid();
export const mutations = influencersCampaignsQuery.mutations();
export const details = influencersCampaignsQuery.details();
export const model = influencersCampaignsQuery.exact();

export const create = mutations.create();
export const update = mutations.update();
export const remove = mutations.delete();
export const batchAddParamsToLink = mutations.mutate('batchAddParamsToLink');
export const batchAddPromoCode = mutations.mutate('batchAddPromoCode');
export const uploadGGCampaigns = mutations.mutate('uploadGGCampaigns');
export const updatedCampaigns = mutations.mutate('updatedCampaigns');
